import ManzamaLogo, {COLORS} from './ManzamaLogo'

export default ManzamaLogo
export {ManzamaLogo, COLORS}
